import { render, staticRenderFns } from "./ClaimFileUpload.vue?vue&type=template&id=3eefea12&scoped=true"
import script from "./ClaimFileUpload.vue?vue&type=script&lang=js"
export * from "./ClaimFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ClaimFileUpload.vue?vue&type=style&index=0&id=3eefea12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eefea12",
  null
  
)

export default component.exports